<template>
  <div v-if="isLoading">
    <loading />
  </div>
  <div v-else class="p-10">
    <excelExport @exportexcel="getExcel()" />
    <table class="font-thin text-gray-700 text-sm table-auto">
      <thead class="font-black text-left">
        <tr>
          <td>
            <div class="page-header-space"></div>
          </td>
        </tr>
        <tr>
          <td colspan="5">
            <h1>
              Listado fabricantes
            </h1>
          </td>
        </tr>
        <tr>
          <td class="w-4/12">Nombre</td>
          <td class="w-4/12">Domicilio</td>
          <td class="w-2/12">Telefono/Móvil</td>
          <td class="w-2/12">e-mail</td>
        </tr>
      </thead>
      <tr v-for="fabricante in report.fabricantes" :key="fabricante.idFabricante">
        <td colspan="4">
          <table class="border-b">
            <tr>
              <td class="w-4/12 p-1">
                {{ fabricante.nombreFabricante }}
              </td>
              <td class="w-4/12 p-1">
                {{ fabricante.domicilio }}
              </td>
              <td class="w-2/12 p-1">
                {{ fabricante.telefono }}
              </td>
              <td class="w-2/12 p-1">
                {{ fabricante.email }}
              </td>
            </tr>
            <tr>
              <td class="w-4/12 p-1"></td>
              <td class="w-4/12 p-1">
                {{ fabricante.codigoPostal }}  {{ fabricante.poblacion }}
              </td>
              <td class="w-2/12 p-1">
                {{ fabricante.movil }}
              </td>
              <td class="w-2/12 p-1"></td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="border-t border-gray-800">
        <td colspan="1" class="w-4/12 p-1">
          TOTAL FABRICANTES:
        </td>
        <td colspan="3" class="w-8/12 p-1 font-semibold text-left">
          {{ report.totalFabricantes }}
        </td>
      </tr>
      <tfoot>
        <tr>
          <td>
            <div class="page-footer-space"></div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <footerPage></footerPage>
  <div class="header p-10">
    <table>
      <tr>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { FabricantesFabricantes } from "@/types/reports/fabricantes/fabricantesFabricantes/FabricantesFabricantes";
import { FabricanteFilter } from "@/types/fabricantes/FabricanteView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<FabricantesFabricantes> = ref({
      totalFabricantes: "",
      fabricantes: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("fabricanteFilter");
      let filter = {} as FabricanteFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportFabricantesFabricantesDB(filter);
      report.value = response;
      //console.log(report);
      isLoading.value = false;
    }

    async function getExcel() {
      const filterString = localStorage.getItem("fabricanteFilter");
      let filter = {} as FabricanteFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      apiExcel.getReportFabricantesFabricantesDB(filter);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
</script>
<style scoped>
table {
  width: 100%;
}

table table {
  text-align: left;
}

thead td {
  text-align: center;
}

.bloque {
  page-break-inside: avoid;
}

.header {
  font-size: 9px;
  line-height: 10px;
  position: fixed;
  top: 0;
  visibility: hidden;
  counter-increment: page;
}

@media print {
  table {
    font-size: 10px;
  }
  td {
    line-height: 0.75rem;
  }
  @page {
    size: portait;
  }

  .header {
    visibility: visible;
  }

  .page-footer-space {
    height: 20px;
  }

  .page-header-space {
    height: 0px;
  }
}
</style>